import { useMemo } from "react";
import { filter, includes, map, sortBy } from "lodash";
import { Modal } from "@linkfluence/core/modal";
import { useCurrentUserLocale } from "@linkfluence/core/user/use-cases";
import { natural } from "@tootools/sort";
import { Status } from "@radarly/models/filters";

const MODALE_ID = "modale_queries_selector";

export function useWizardQueriesSelector({
  options,
  values,
  onChange,
  onValidate = () => null,
}: {
  options: Array<{ label: string; value: number }>;
  values?: number[];
  onChange: (value: number[]) => void;
  onValidate?: () => void;
}) {
  const { open, close, ModalWrapper } = Modal.get(MODALE_ID);

  const locale = useCurrentUserLocale();

  const onApply = (values) => {
    onChange(map(values, "value"));
    onValidate();
    close();
  };
  const onGlobalSelect = (status: Status) => {
    if (status === Status.Include) {
      onChange(map(options, "value"));
      return onValidate();
    }
    onChange([]);
    return onValidate();
  };

  const onUnSelect = (query) => {
    const newValues = filter(values, (val) => val !== query);
    onChange(newValues);
    onValidate();
  };

  const selectedQueries = useMemo(() => {
    const filteredQueries = filter(options, (option) =>
      includes(values, option.value)
    );
    return sortBy(filteredQueries, "label");
  }, [options, values]);

  const formatedOptions = natural(
    map(options, (option) => ({
      ...option,
      id: option.label,
      status: includes(values, option.value) ? Status.Include : Status.None,
      position: 0,
    })),
    "label"
  );

  return {
    locale,
    open,
    ModalWrapper,
    close,
    selectedQueries,
    formatedOptions,
    onGlobalSelect,
    onApply,
    onUnSelect,
  };
}
